/**
 * STAAR-557: Australia, South East Asia and New Zealand hide the header navigation and the mobile menu links.
 * Matched by locale and by site handle (the South East Asia site shares en-AU).
 */
export function hideRegionalNav(siteInfo: { iso?: string; handle?: string | null }): boolean {
  return siteInfo.iso === 'en-AU' || ['southEastAsia', 'australia', 'newZealand'].includes(siteInfo.handle ?? '')
}
